module.exports = __webpack_public_path__ + "img/icon_service_red.bfd157a5.svg";